import React, { Fragment, useState, useEffect } from "react";
import man from "../../../assets/images/dashboard/user.png";
import { User, Mail, Lock, Settings, LogOut } from "react-feather";
import app from "../../../data/base";
import { Link } from "react-router-dom";
import { Edit } from "react-feather";
import four from "../../../assets/images/avtar/3.jpg";
import { apiURL } from "../../../utlis/config";
import { useLocation, withRouter } from "react-router";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import store from "store";
import "./usermenu.css"

var memberInfo = store.get("staffMember");

class UserMenu extends React.Component {
  state = { memberInfo: store.get("staffMember"), toggle: false };
  componentDidMount() {
    var self = this;
    document.addEventListener("memberInfo", function (e) {
      // Prints "Example of an event"
      memberInfo = e.detail.memberInfo;
      console.log({ memberInfo }, "memberInfo");
      // setMemberInfo(memberInfo);
      self.setState({ memberInfo });
    });
  }
  onToggle = () => {
    const { memberInfo, toggle } = this.state;
    this.setState({ toggle: !toggle });
  };
  render() {
    const { memberInfo, toggle } = this.state;
    console.log("this.props", this.props);
    const logout = (e) => {
      localStorage.clear();
      // window.location.reload();
      // return <Redirect to="/login"></Redirect>;
      // this.props.history.push(`${process.env.PUBLIC_URL}/login`);
      this.props.history.push(`${process.env.PUBLIC_URL}/login`);
    };
    return (
      // <Fragment>
      //   <li className="onhover-dropdown">
      //     <div className="media align-items-center">
      //       <img
      //         className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
      //         src={
      //           memberInfo && memberInfo.profilePicUrl
      //             ? `${apiURL}${memberInfo.profilePicUrl}`
      //             : four
      //         }
      //         alt="header-user"
      //       />
      //     </div>
      //     <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
      //       <li>
      //         <Link to="/profile">
      //           <User />
      //           Profile
      //         </Link>
      //       </li>
      //       <li>
      //         <a
      //           onClick={() => {
      //             this.setState({ toggle: !toggle });
      //           }}
      //         >
      //           <LogOut /> Log out
      //           <Modal isOpen={toggle} toggle={() => this.onToggle()}>
      //             <ModalHeader toggle={() => this.onToggle()}>
      //               Log out
      //             </ModalHeader>
      //             <ModalBody>
      //               Are you sure you want to logout from Admin Dashboard?
      //             </ModalBody>
      //             <ModalFooter>
      //               <Button color="default" onClick={() => this.onToggle()}>
      //                 Cancel
      //               </Button>
      //               <Button color="danger" onClick={() => logout()}>
      //                 Confirm
      //               </Button>
      //             </ModalFooter>
      //           </Modal>
      //         </a>
      //       </li>
      //     </ul>
      //   </li>
      // </Fragment>
      <Fragment>
        <div className="profile-dropdown">
          <img
            className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded profile-dropdown-button"
            src={
              memberInfo && memberInfo.profilePicUrl
                ? `${apiURL}${memberInfo.profilePicUrl}`
                : four
            }
            alt="header-user"
          />
          <ul className="profile-dropdown-content">
            <li>
              <Link to="/profile">
                <User style={{width:"18px", height:"18px"}}/>
                Profile
              </Link>
            </li>
            <li>
              <a
                onClick={() => {
                  this.setState({ toggle: !toggle });
                }}
              >
                <LogOut style={{width:"18px", height:"18px"}}/> Log out
                <Modal isOpen={toggle} toggle={() => this.onToggle()}>
                  <ModalHeader toggle={() => this.onToggle()}>
                    Log out
                  </ModalHeader>
                  <ModalBody>
                    Are you sure you want to logout from Admin Dashboard?
                  </ModalBody>
                  <ModalFooter>
                    <Button color="default" onClick={() => this.onToggle()}>
                      Cancel
                    </Button>
                    <Button color="danger" onClick={() => logout()}>
                      Confirm
                    </Button>
                  </ModalFooter>
                </Modal>
              </a>
            </li>
          </ul>
        </div>
      </Fragment >
    );
  }
}

export default withRouter(UserMenu);
